// extracted by mini-css-extract-plugin
export default {"Emoji":"bbm_a bhn_i bhn_q bhn_j"};